import React, { useContext } from 'react'
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Poppers from '@material-ui/core/Popper'
// @material-ui/icons
import Person from '@material-ui/icons/Person'
// core components
import styles from 'assets/jss/dorm-app/components/headerLinksStyle.js'
import Button from '../button/RegularButton'
import { useHistory } from 'react-router-dom'
import { emptyUser, UserContext } from '../../App'

const useStyles = makeStyles(styles)

export default function NavbarLinks() {
  const classes = useStyles()
  const hist = useHistory()
  const { setUser } = useContext(UserContext)
  const [open, setOpen] = React.useState(false)
  const [openProfile, setOpenProfile] = React.useState(false)

  const handleLogout = () => {
    localStorage.removeItem('token')
    setUser(emptyUser)
    hist.push('/login')
    window.location.reload(false)
  }
  const handleClickProfile = (event) => {
    if (open) {
      setOpenProfile(null)
      setOpen(false)
    } else {
      setOpenProfile(event.currentTarget)
      setOpen(true)
    }
  }
  const handleCloseProfile = () => {
    setOpenProfile(null)
  }
  return (
    <div>
      <div className={classes.manager}>
        <Button
          color={window.innerWidth > 959 ? 'transparent' : 'white'}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openProfile ? 'profile-menu-list-grow' : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}>
          <Person className={classes.icons} />
        </Button>
        <Poppers
          open={open}
          anchorEl={openProfile}
          transition
          disablePortal
          className={classNames({ [classes.popperClose]: !open }) + ' ' + classes.popperNav}>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list-grow"
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}>
              <Paper>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    <MenuItem onClick={handleLogout} className={classes.dropdownItem}>
                      Logout
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
    </div>
  )
}
